import React from "react";
import { at } from "lodash";
import { useField } from "formik";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";

const CheckboxField = (props) => {
  const { label, isDisabled, ...rest } = props;
  const [field, meta, helper] = useField(props);
  const { setValue } = helper;

  const renderHelperText = () => {
    const [touched, error] = at(meta, "touched", "error");
    if (touched && error) {
      return <FormHelperText>{error}</FormHelperText>;
    }
  };

  function onChange(e) {
    setValue(e.target.checked);
  }

  return (
    <FormControl {...rest}>
      <FormControlLabel
        value={field.checked}
        checked={field.checked}
        control={
          <Checkbox {...field} onChange={onChange} disabled={isDisabled} />
        }
        label={label}
      />
      {renderHelperText()}
    </FormControl>
  );
};
export default CheckboxField;
